/* LES Countdown Timer
   Adds a countdown to the first event card on the homepage
   Reads the event date from the card's text content */

(function() {
  if (document.querySelector('[data-template="index"]') === null) return;

  function initCountdown() {
    var firstCard = document.querySelector('.resource-list__item:first-child .product-card__content');
    if (!firstCard) return;

    var strongTags = firstCard.querySelectorAll('.rte strong');
    if (!strongTags.length) return;

    var dateText = strongTags[0].textContent.trim();
    var eventDate = parseEventDate(dateText);
    if (!eventDate || isNaN(eventDate.getTime())) return;

    var countdown = document.createElement('div');
    countdown.id = 'les-countdown';
    countdown.setAttribute('style',
      'display: flex; gap: 8px; padding: 2px 24px 8px; grid-column: 2; width: fit-content; justify-self: start;'
    );

    var targetEl = null;
    var children = firstCard.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].querySelector('.rte') || children[i].classList.contains('rte')) {
        targetEl = children[i];
        break;
      }
    }

    if (targetEl) {
      targetEl.parentNode.insertBefore(countdown, targetEl);
    } else {
      var secondChild = firstCard.children[1];
      if (secondChild && secondChild.nextSibling) {
        firstCard.insertBefore(countdown, secondChild.nextSibling);
      } else {
        firstCard.appendChild(countdown);
      }
    }

    updateCountdown(countdown, eventDate);
    setInterval(function() {
      updateCountdown(countdown, eventDate);
    }, 1000);
  }

  function parseEventDate(text) {
    text = text.replace(/(\d+)(st|nd|rd|th)/gi, '$1');

    var currentYear = new Date().getFullYear();
    var dateString = text + ' ' + currentYear;

    var date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      if (date < new Date()) {
        date = new Date(text + ' ' + (currentYear + 1));
      }
      return date;
    }

    var months = {
      'jan': 0, 'feb': 1, 'mar': 2, 'apr': 3, 'may': 4, 'jun': 5,
      'jul': 6, 'aug': 7, 'sep': 8, 'oct': 9, 'nov': 10, 'dec': 11
    };

    var parts = text.match(/([a-z]+)\s+(\d+)\s+(\d+:\d+\s*[ap]m?)/i);
    if (parts) {
      var monthStr = parts[1].toLowerCase().substring(0, 3);
      var day = parseInt(parts[2]);
      var timeStr = parts[3];

      if (months[monthStr] !== undefined) {
        var timeParts = timeStr.match(/(\d+):(\d+)\s*([ap]m?)/i);
        if (timeParts) {
          var hours = parseInt(timeParts[1]);
          var minutes = parseInt(timeParts[2]);
          var ampm = timeParts[3].toLowerCase();

          if (ampm.charAt(0) === 'p' && hours !== 12) hours += 12;
          if (ampm.charAt(0) === 'a' && hours === 12) hours = 0;

          var result = new Date(currentYear, months[monthStr], day, hours, minutes);
          if (result < new Date()) {
            result = new Date(currentYear + 1, months[monthStr], day, hours, minutes);
          }
          return result;
        }
      }
    }

    return null;
  }

  function updateCountdown(el, targetDate) {
    var now = new Date().getTime();
    var distance = targetDate.getTime() - now;

    if (distance < 0) {
      el.innerHTML = '<div style="' + pillStyle('#e24e1b') + '"><span style="' + numStyle() + '">NOW</span><span style="' + labelStyle() + '">Event started</span></div>';
      return;
    }

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var secs = Math.floor((distance % (1000 * 60)) / 1000);

    el.innerHTML =
      '<div style="' + pillStyle('#1d3fba') + '"><span style="' + numStyle() + '">' + days + '</span><span style="' + labelStyle() + '">days</span></div>' +
      '<div style="' + pillStyle('#1d3fba') + '"><span style="' + numStyle() + '">' + pad(hours) + '</span><span style="' + labelStyle() + '">hrs</span></div>' +
      '<div style="' + pillStyle('#1d3fba') + '"><span style="' + numStyle() + '">' + pad(mins) + '</span><span style="' + labelStyle() + '">min</span></div>' +
      '<div style="' + pillStyle('#1d3fba') + '"><span style="' + numStyle() + '">' + pad(secs) + '</span><span style="' + labelStyle() + '">sec</span></div>';
  }

  function pillStyle(bg) {
    return 'background:' + bg + ';color:#fff;border-radius:6px;padding:7px 10px;text-align:center;min-width:48px;display:flex;flex-direction:column;align-items:center;';
  }

  function numStyle() {
    return 'font-size:18px;font-weight:700;line-height:1.1;display:block;';
  }

  function labelStyle() {
    return 'font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:0.1em;opacity:0.85;display:block;margin-top:2px;';
  }

  function pad(n) {
    return n < 10 ? '0' + n : n;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initCountdown, 500);
    });
  } else {
    setTimeout(initCountdown, 500);
  }
})();